import { render } from "./Kubernetes.vue?vue&type=template&id=3b213fd6"
import script from "./Kubernetes.vue?vue&type=script&lang=js"
export * from "./Kubernetes.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__